// Phase 5 - US3: Invitation Types (T095)

export enum DeliveryStatus {
  PENDING = 'PENDING',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  BOUNCED = 'BOUNCED',
}

export interface SurveyInvitation {
  id: string;
  surveyId: string;
  contractorId: string;
  recipientEmail?: string;
  recipientPhone?: string;
  sentAt?: string;
  deliveryStatus: DeliveryStatus;
  errorMessage?: string;
  createdAt: string;
}

export interface InvitationStats {
  total: number;
  pending: number;
  sent: number;
  delivered: number;
  failed: number;
}

export interface BulkInviteResult {
  queued: number;
  failed: number;
  parseErrors: Array<{
    row: number;
    data: any;
    errors: string[];
  }>;
  sendErrors: Array<{
    recipient: any;
    error: string;
  }>;
}
